import "./style.scss";
import LayoutProvider from "../../../../providers/LayoutProvider";
import AchievementCard from "../../../../components/Training/achivement/AchievementCard";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import { getApprovedEndorsementsFromApi, getEndorsements } from "../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../store/slices/auth-slice";
import { ROLES } from "../../../../constants";
import React, { useMemo, useState } from "react";
import { getApprovedRatingsData, getApprovedRatingsFromApi } from "../../../../store/slices/request-signature.slice";
import { Toaster } from "react-hot-toast";
import StudentPagesProvider from "../../../../providers/StudentPagesProvider";
import StudentCardTwo from "../../../../components/Training/students/StudentCardTwo";
import { FiPlus } from "react-icons/fi";
import useCustomToast from "../../../../hooks/useCustomToast";
import { useDropzone } from "react-dropzone";
import DocumentService from "../../../../services/document.service";
import { confirmAlert } from "react-confirm-alert";
import SpinnerLoader from "../../../../components/SpinnerLoader";
function Achievement() {

  const endorsements = useAppSelector(getEndorsements)
  const ratings = useAppSelector(getApprovedRatingsData)
  const user = useAppSelector(getUser)
  const dispatch = useAppDispatch()

  const [documents, setDocuments] = useState<any>([]);
  const [showDropZone, setShowDropZone] = useState<boolean>(false);
  const [label, setLabel] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const customToast = useCustomToast()

  const { getRootProps, getInputProps, open, isFocused, acceptedFiles } =
    useDropzone({
      noClick: true,
      noKeyboard: true,
      multiple: false,
      maxFiles: 1,
    });

  const getDocuments = async () => {
    const data: any = await DocumentService.find()
    setDocuments(data)

  }
  React.useEffect(() => {
    if (user?.role === ROLES.STUDENT) {
      dispatch(getApprovedEndorsementsFromApi())
      dispatch(getApprovedRatingsFromApi())
      getDocuments()
    }
  }, [dispatch, user?.role])

  const baseStyle: any = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fff",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#000 !important",
  };

  const style: any = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
    }),
    [isFocused]
  );


  const uploadDocument = async () => {
    if (!acceptedFiles.length) return customToast("Please select the document file", "error")
    if (!label) return customToast("Please enter document title", "error")

    const formData = new FormData()
    formData.append("label", label)
    formData.append("document", acceptedFiles[0])

    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to upload this document?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            setLoading(true)
            const res: any = await DocumentService.upload(formData)
            setLoading(false)
            if (res?.status === 200) {
              customToast(res?.message, "success", 2000)
              setTimeout(() => {
                setLabel("")
                setShowDropZone(false)
                getDocuments()
              }, 1000)
            }
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })

  }

  const removeDocument = async (id: string) => {
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to remove this document?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            const res: any = await DocumentService.delete(id)
            if (res?.status === 200) {
              customToast(res?.message, "success")
              setDocuments((prev: any) => ({ ...prev, documents: prev.documents.filter((doc: any) => doc._id !== id) }))
            }
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }

  return (
    <StudentPagesProvider>
      <LayoutProvider>
        {loading && <SpinnerLoader />}
        <Toaster />
        <div className="achievements_page">
          <h2 className="heading2">Achievements</h2>
          <div className="wrapper my-2">
            <h3 className="heading3">Endorsements</h3>
            <div className="achievements">
              {endorsements?.map((achievement: any, i: number) => (
                <AchievementCard key={i} achievement={achievement} />
              ))}
            </div>
          </div>
          <div className="wrapper my-2">
            <h3 className="heading3">Ratings</h3>
            <div className="achievements">
              {ratings?.map((achievement: any, i: number) => (
                <AchievementCard key={i} achievement={achievement} />
              ))}
            </div>
          </div>
          <div className="wrapper my-2">
            <h3 className="heading3">Documents</h3>

            {showDropZone && (
              <div {...getRootProps({ className: "dropzone", style })}>
                <input {...getInputProps()} />
                <h3 className="heading3 my-1 text-center" style={{ color: "#000" }}>
                  {acceptedFiles?.length ? (
                    acceptedFiles[0].name
                  ) : (
                    <span>
                      Drop your document file here<br />
                      <small className="d-block pt-1 " style={{ color: "#808080" }}>
                        or
                      </small>
                    </span>
                  )}
                </h3>
                <button
                  type="button"
                  style={{
                    borderRadius: 6,
                    outline: "none",
                    padding: "6px 20px 6px 20px",
                    color: "#000",
                    background: "#EEEEEE",
                    border: "1px solid #808080",
                  }}
                  onClick={open}
                >
                  Select Document
                </button>
                <div className="d-flex gap-2 mt-4 align-items-center">
                  <input className="form-control" value={label} onChange={(e: any) => setLabel(e.target.value)} placeholder="Enter document title" style={{ maxWidth: 300, boxShadow: "none" }} />
                  <button className="button" onClick={uploadDocument} disabled={loading}>{loading ? "Uploading..." : "Submit"}</button>
                </div>
              </div>
            )}
            <div className="achievements documents_section">

              <div className="row my-3 w-100">
                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div className="students_card_tow align-items-center">
                    <button
                      className="add_file_btn"
                      onClick={() => setShowDropZone(!showDropZone)}
                    >
                      <span className="icon">
                        <FiPlus />
                      </span>
                      <span>Add New Document</span>
                    </button>
                  </div>
                </div>
                {documents?.documents?.map((document: any) => (
                  <StudentCardTwo key={document?._id} document={document} folder={documents?.key} removeDocument={removeDocument} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </LayoutProvider>
    </StudentPagesProvider>
  );
}

export default Achievement;
